<template>
  <div class="d-activity-activity">
    <DActivityCommentActivity
      v-if="activity.type === 'ActivityCommentActivity'"
      :activity="activity"
      :is-repost="isRepost"
      :is-user-signed-in="isUserSignedIn"
      @activity-removed="activityRemoved"
    />

    <DAddUserReviewActivity
      v-if="activity.type === 'AddUserReviewActivity'"
      :activity="activity"
      :is-repost="isRepost"
      :is-user-signed-in="isUserSignedIn"
      @activity-removed="activityRemoved"
    />

    <DBadgeUnlockedActivity
      v-if="activity.type === 'BadgeUnlockedActivity'"
      :activity="activity"
      :is-repost="isRepost"
      :is-user-signed-in="isUserSignedIn"
      @activity-removed="activityRemoved"
    />

    <DBookCommentActivity
      v-if="activity.type === 'BookCommentActivity'"
      :activity="activity"
      :is-repost="isRepost"
      :is-user-signed-in="isUserSignedIn"
      @activity-removed="activityRemoved"
    />

    <DFeedPostActivity
      v-if="activity.type === 'FeedPostActivity'"
      :activity="activity"
      :is-repost="isRepost"
      :is-user-signed-in="isUserSignedIn"
      @activity-removed="activityRemoved"
    />

    <DLaunchedBookActivity
      v-if="activity.type === 'LaunchedBookActivity'"
      :activity="activity"
      :is-repost="isRepost"
      :is-user-signed-in="isUserSignedIn"
      @activity-removed="activityRemoved"
    />

    <DLaunchedReviewActivity
      v-if="activity.type === 'LaunchedReviewActivity'"
      :activity="activity"
      :is-repost="isRepost"
      :is-user-signed-in="isUserSignedIn"
      @activity-removed="activityRemoved"
    />

    <DNewBookshelfEntryActivity
      v-if="activity.type === 'NewBookshelfEntryActivity'"
      :activity="activity"
      :is-repost="isRepost"
      :is-user-signed-in="isUserSignedIn"
      @activity-removed="activityRemoved"
    />

    <DNewFollowActivity
      v-if="activity.type === 'NewFollowActivity'"
      :activity="activity"
      :is-repost="isRepost"
      :is-user-signed-in="isUserSignedIn"
      @activity-removed="activityRemoved"
    />

    <DNewFollowsActivity
      v-if="activity.type === 'NewFollowsActivity'"
      :activity="activity"
      :is-repost="isRepost"
      :is-user-signed-in="isUserSignedIn"
      @activity-removed="activityRemoved"
    />

    <DGoodreadsImportActivity
      v-if="activity.type === 'GoodreadsImportActivity'"
      :activity="activity"
      :is-repost="isRepost"
      :is-user-signed-in="isUserSignedIn"
      @activity-removed="activityRemoved"
    />

    <DUpvoteActivityActivity
      v-if="activity.type === 'UpvoteActivityActivity' ||
        (activity.type === 'UpvoteBookActivity' && activity.source_type !== 'Book')"
      :activity="activity"
      :is-repost="isRepost"
      :is-user-signed-in="isUserSignedIn"
      @activity-removed="activityRemoved"
    />

    <DUpvoteBookActivity
      v-if="(activity.type === 'UpvoteBookActivity' && activity.source_type === 'Book')"
      :activity="activity"
      :is-repost="isRepost"
      :is-user-signed-in="isUserSignedIn"
      @activity-removed="activityRemoved"
    />
  </div>
</template>

<script>
import DActivityCommentActivity from './d-activity-comment-activity/d-activity-comment-activity.vue';
import DAddUserReviewActivity from './d-add-user-review-activity/d-add-user-review-activity.vue';
import DBadgeUnlockedActivity from './d-badge-unlocked-activity/d-badge-unlocked-activity.vue';
import DBookCommentActivity from './d-book-comment-activity/d-book-comment-activity.vue';
import DFeedPostActivity from './d-feed-post-activity/d-feed-post-activity.vue';
import DGoodreadsImportActivity from './d-goodreads-import-activity/d-goodreads-import-activity.vue';
import DLaunchedBookActivity from './d-launched-book-activity/d-launched-book-activity.vue';
import DLaunchedReviewActivity from './d-launched-review-activity/d-launched-review-activity.vue';
import DNewBookshelfEntryActivity from './d-new-bookshelf-entry-activity/d-new-bookshelf-entry-activity.vue';
import DNewFollowActivity from './d-new-follow-activity/d-new-follow-activity.vue';
import DNewFollowsActivity from './d-new-follows-activity/d-new-follows-activity.vue';
import DUpvoteActivityActivity from './d-upvote-activity-activity/d-upvote-activity-activity.vue';
import DUpvoteBookActivity from './d-upvote-book-activity/d-upvote-book-activity.vue';

export default {
  components: {
    DActivityCommentActivity,
    DAddUserReviewActivity,
    DBadgeUnlockedActivity,
    DBookCommentActivity,
    DFeedPostActivity,
    DGoodreadsImportActivity,
    DLaunchedBookActivity,
    DLaunchedReviewActivity,
    DNewBookshelfEntryActivity,
    DNewFollowActivity,
    DNewFollowsActivity,
    DUpvoteActivityActivity,
    DUpvoteBookActivity,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
    isRepost: {
      type: Boolean,
      default: false,
    },
    isUserSignedIn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    activityRemoved() {
      this.$emit('activity-removed');
    },
  },
};
</script>
